import './main.css'
import Alpine from 'alpinejs'
import axios from 'axios'
import { reduce } from 'lodash'
import { Notyf } from 'notyf'
import 'notyf/notyf.min.css'

window.Alpine = Alpine
window.axios = axios

const notyf = new Notyf({
    duration: 3000,
    position: { x: 'center', y: 'bottom' }
})

const fireSuccess = (message) => {
    const success = notyf.success({
        message: message,
        className: 'toaster toaster--success',
        icon: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">\n' +
            '  <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />\n' +
            '</svg>\n'
    })
    success.on('click', () => notyf.dismiss(success))
}

const copyLink = async (value) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
        try {
            await navigator.clipboard.writeText(value)
            console.log('Link copied successfully:', value)
        } catch (error) {
            console.error('Failed to copy the link:', error)
        }
    } else {
        console.warn('Clipboard API is not supported. Falling back to manual copy.')
        // Fallback to manual copy
        const tempInput = document.createElement('input')
        tempInput.value = value
        document.body.appendChild(tempInput)
        tempInput.select()
        document.execCommand('copy')
        document.body.removeChild(tempInput)
        console.log('Link copied manually:', value)
    }
}

const axiosInstance = axios.create({
    headers: {
        'X-WP-Nonce': wpflp.rest_nonce
    }
})

const submit = (url, data) => {
    return axiosInstance.post(url, data)
}

Alpine.store('dialog', {
    open: null,
    data: {},
    confirm(type, data = {}) {
        this.open = type
        this.data = data
    }
})

Alpine.start()
